import { bunja } from 'bunja';
import { Atom, atom } from 'jotai';

import { getPrexInstallationId } from '@flipster/utils/localStorage';

import { getFlag } from '../../flag';

/**
 * 구 Amplitude Experiment 자리를 대신하는 피처 플래그 조회 레이어.
 *
 * Amplitude 구독 종료로 원격 조회가 사라졌고, 값은 이제 features/src/flag 의
 * 빌드타임 상수(defineFlag)에서 온다. 서버와 클라이언트가 같은 값을 보므로
 * 예전처럼 하이드레이션 가드(defaultWhileAtom)를 걸 필요가 없다.
 *
 * dev tool > Flag > Feature Flags 에서 토글하면 세션 단위로 값을 뒤집어
 * 반대 경로를 확인할 수 있다 (updateFlagsAndReload가 페이지를 리로드한다).
 */

/**
 * 피처 플래그 활성 여부.
 *
 * @param flagKey features/src/flag 에 defineFlag 로 등록된 키. 미등록 키는 false.
 * @param _targetVariant 구 Amplitude variant 이름. 값이 boolean 상수로 바뀐 뒤로는 비교할
 *   variant가 없어 무시한다. 호출부 표기를 유지하려고 남긴 인자이며, 무시되는 값이
 *   반대로 읽히지 않도록 'on'만 받는다(구 'off'/'control' 호출은 컴파일 에러).
 */
export function useAbFlag(flagKey: string, _targetVariant?: 'on'): boolean {
  return getFlag(flagKey);
}

export const abTestBunja = bunja(() => {
  /** API 헤더 X-Prex-Installation-Id 용 설치 식별자. 플래그와 무관하지만 소비자가 여기서 받아간다. */
  const prexInstallationId = getPrexInstallationId();

  const flagAtoms: Record<string, Atom<boolean>> = {};
  /** 상수라 값이 바뀌지 않으므로 키당 하나의 정적 atom을 재사용한다. */
  function getAbFlagAtom(flagKey: string, _targetVariant?: 'on'): Atom<boolean> {
    return (flagAtoms[flagKey] ??= atom(getFlag(flagKey)));
  }

  return { getAbFlagAtom, prexInstallationId };
});
abTestBunja.debugLabel = 'abTestBunja';
